// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZPgM","location":"Header_location__3VYxI"};